import { render, staticRenderFns } from "./ItemVariationAttribute.vue?vue&type=template&id=3d5b93da&scoped=true"
import script from "./ItemVariationAttribute.vue?vue&type=script&lang=js"
export * from "./ItemVariationAttribute.vue?vue&type=script&lang=js"
import style0 from "./ItemVariationAttribute.vue?vue&type=style&index=0&id=3d5b93da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b93da",
  null
  
)

export default component.exports